// extracted by mini-css-extract-plugin
export default {"card":"TimedPromotion_card__ws0oW","cardDisabled":"TimedPromotion_cardDisabled__9EsEg"};